module.exports = __webpack_public_path__ + "img/haefele_berater_app.383ad84d.png";